import { PeripheralType } from './Peripheral'

export enum PeripheralManufacturerType {
  Bematech = 'BEMATECH',
}

export enum CommandType {
  ESCPos = 'ESCPOS',
  ESCBema = 'ESCBEMA'
}

export interface PeripheralManufacturer {
  encodedName: string
  name: string
  types: PeripheralType[]
  commandTypes?: CommandType[]
  printerModels?: string[]
  scaleModels?: string[]
  satModels?: string[]
}
